import { LoaderFunctionArgs } from 'react-router';
import { playerApi } from '@repo/api-client';
import { urlControlPanel, urlPlayerList } from '@/urls';
import { Players } from './players';
import { getPagination } from '@repo/api-client';

export const route = {
  path: urlPlayerList(':id'),
  element: <Players />,
  handle: {
    title: 'Jugadores',
    backLink: (params: { id: string }) => urlControlPanel(params.id),
  },
  loader: async ({ params, request }: LoaderFunctionArgs) => {
    const clubId = params.id as string;
    const pagination = getPagination(request);
    const players = await playerApi.getPlayers(clubId, pagination);
    return { players };
  },
};
